import { Tooltip } from "../../Tooltip/index.js";
import { Link } from "../../Link/index.js";
import React from "react";
import { cn } from "@synthesis/shared-utils";
import { jsx, jsxs } from "react/jsx-runtime";
import { useRouterState } from "@tanstack/react-router";
//#region src/Navbar/local-components/ItemGroup.tsx
const ItemLink = React.forwardRef(({ isCollapsed, className, children, href, to, target, rel, ...rest }, ref) => {
	const linkClassName = cn("flex w-full items-center rounded-xl duration-200 ease-in-out", isCollapsed ? "justify-center py-0.5 hover:bg-white" : "px-0", className);
	if (href) return /* @__PURE__ */ jsx("a", {
		ref,
		href,
		download: href,
		target,
		rel,
		className: linkClassName,
		...rest,
		children
	});
	return /* @__PURE__ */ jsx(Link, {
		ref,
		to: to ?? "/",
		target,
		visited: false,
		className: cn(linkClassName, "no-underline decoration-transparent"),
		...rest,
		children
	});
});
ItemLink.displayName = "ItemLink";
const IconWrapper = ({ isUniqLink, className, children }) => /* @__PURE__ */ jsx("i", {
	"data-cy": "navbar-iconWrapper-navigation",
	className: cn("text-neutrals-60 hover:text-brand-40 group-hover:text-brand-40 flex size-4 items-center justify-center not-italic", isUniqLink && "text-brand-40", className),
	children
});
const ItemGroup = ({ item, isCollapsedNavBar, handleGetIsUniqLink }) => {
	const pathname = useRouterState({ select: (state) => state.location.pathname });
	const isUniqLink = handleGetIsUniqLink(item);
	const isActiveContainLink = Boolean(item.activeWith && pathname.includes(item.activeWith));
	return /* @__PURE__ */ jsx(Tooltip, {
		"data-cy": "navbar-tooltip-navigation",
		disabled: !isCollapsedNavBar,
		description: item.name,
		arrowSide: "right",
		arrowAlign: "center",
		delayDuration: 0,
		sideOffset: 0,
		children: /* @__PURE__ */ jsxs(ItemLink, {
			isCollapsed: isCollapsedNavBar,
			href: item.href,
			to: item.link,
			target: item.isOpenInNewTab ? "_blank" : void 0,
			rel: item.isOpenInNewTab ? "noopener noreferrer" : void 0,
			children: [/* @__PURE__ */ jsx("div", {
				className: cn("duration-200 ease-in-out", isCollapsedNavBar ? "opacity-100" : "opacity-0"),
				children: /* @__PURE__ */ jsx(IconWrapper, {
					isUniqLink,
					children: item.icon ?? /* @__PURE__ */ jsx("figure", { className: cn("size-2.5 rounded-full border-2", isUniqLink || isActiveContainLink ? "border-brand-40 bg-brand-40" : "border-type-light") })
				})
			}), /* @__PURE__ */ jsx("div", {
				"data-cy": "itemGroup-item",
				className: cn("text-labels-secondary hover:text-brand-40 py-1.5 text-xs font-medium leading-4 duration-200 ease-in-out", isUniqLink && "text-brand-40", isCollapsedNavBar ? "invisible w-0 truncate opacity-0" : "visible w-full opacity-100", isActiveContainLink && "text-brand-40", item.nonTruncate ? void 0 : "truncate"),
				children: item.name
			})]
		})
	});
};
//#endregion
export { IconWrapper, ItemGroup };

//# sourceMappingURL=ItemGroup.js.map